// extracted by mini-css-extract-plugin
export default {"paper":"code-block_paper__-jxI8","block-header":"code-block_block-header__te5Cg","block-content":"code-block_block-content__rShPS"};